const setSessionAuthToken = token => {
    window.localStorage.setItem('at', token);
};

export default setSessionAuthToken;
